// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hint[data-v-6308a348] {\n  font-size: 12.5px;\n  color: #8c9bab;\n  margin-top: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
